module.exports = __webpack_public_path__ + "static/media/orange-upload-icon.3e07ae87.svg";